import { render, staticRenderFns } from "./StandardChart.vue?vue&type=template&id=8c9e3a4a"
import script from "./StandardChart.vue?vue&type=script&lang=js"
export * from "./StandardChart.vue?vue&type=script&lang=js"
import style0 from "./StandardChart.vue?vue&type=style&index=0&id=8c9e3a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports